import React from 'react';
import { Shield, Globe, Leaf, Laptop, CheckCircle } from 'lucide-react';
import { Section } from './ui/Section';
const services = [{
  icon: Shield,
  title: 'Quality Assurance in TVET',
  description: 'We support the design, implementation, and strengthening of Quality Assurance (QA) systems for TVET institutions and programmes, ensuring credibility, consistency, and continuous improvement.',
  features: ['Development of internal and external QA frameworks for TVET providers', 'Review and improvement of TVET curricula, learning outcomes, and assessment methods', 'Alignment with national qualification frameworks and international QA standards', 'Support for accreditation, audits, and benchmarking', 'Capacity building for TVET QA units, trainers, and assessors', 'Embedding continuous improvement and feedback mechanisms']
}, {
  icon: Globe,
  title: 'Internationalisation of TVET Curricula',
  description: 'LBAS supports TVET providers in aligning their programmes with international education frameworks, enhancing mobility, recognition, and cross-border cooperation.',
  features: ['Alignment of TVET curricula with Bologna Process principles where applicable', 'Introduction of learning outcomes–based curricula', 'Support on credit systems, modularisation, and qualification transparency', 'Strengthening comparability and recognition of TVET qualifications', 'Facilitating international partnerships and mobility pathways', 'Bridging TVET–HE pathways for lifelong learning and progression']
}, {
  icon: Leaf,
  title: 'Green Transition in TVET',
  description: 'We support TVET systems in integrating green skills and sustainability competencies, ensuring that graduates are prepared for green jobs and emerging sectors.',
  features: ['Integration of green skills and sustainability concepts into TVET curricula', 'Development of training programmes for renewable energy and resource efficiency', 'Capacity building for trainers on green pedagogy and practices', 'Alignment with national green strategies and international sustainability agendas', 'Support for green campuses, workshops, and training environments']
}, {
  icon: Laptop,
  title: 'Digitalisation of TVET',
  description: 'LBAS helps TVET providers harness digital technologies to improve training quality, accessibility, and relevance at all levels of TVET.',
  features: ['Digital transformation strategies for TVET institutions', 'Integration of digital skills, AI awareness, and emerging technologies', 'Support for blended, online, and hybrid training models', 'Digitalisation of assessment, certification, and learner tracking', 'Capacity building for trainers in digital teaching and learning tools', 'Alignment with labour-market digital skills needs']
}];
export function ServicesSection() {
  return <section className="py-16 bg-white" data-id="element-104">
      <div className="container mx-auto px-8" data-id="element-105">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-106">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-3" data-id="element-107">
            Our TVET Services
          </h2>
          <h3 className="text-4xl font-bold text-navy mb-6 font-serif" data-id="element-108">
            Comprehensive TVET Solutions
          </h3>
          <p className="text-gray-600 leading-relaxed" data-id="element-109">
            Supporting TVET modernisation across quality assurance,
            internationalisation, green transition, and digitalisation.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-110">
          {services.map((service, index) => <div key={index} className="p-8 bg-slate-50 border-2 border-slate-200 page-break-inside-avoid" data-id="element-111">
              <div className="flex items-start gap-4 mb-6" data-id="element-112">
                <div className="w-12 h-12 bg-navy text-gold flex items-center justify-center flex-shrink-0" data-id="element-113">
                  <service.icon className="w-6 h-6" data-id="element-114" />
                </div>
                <h4 className="text-xl font-bold text-navy font-serif pt-2" data-id="element-115">
                  {service.title}
                </h4>
              </div>

              <p className="text-gray-600 mb-6 text-sm leading-relaxed" data-id="element-116">
                {service.description}
              </p>

              <div className="space-y-2" data-id="element-117">
                {service.features.map((feature, idx) => <div key={idx} className="flex items-start text-sm text-slate-700" data-id="element-118">
                    <CheckCircle className="w-4 h-4 text-gold mr-2 mt-0.5 flex-shrink-0" data-id="element-119" />
                    <span data-id="element-120">{feature}</span>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}